export default __webpack_public_path__ + "static/media/hbs-bpk-3.a68df230.png";